import sendApiRequest from "../../apiRequestHandler";
import { PeriodFeeRequestModel } from "../../models/PeriodFeeRequestModel";
import { PeriodFeeResponseModel } from "../../models/PeriodFeeResponseModel";

const CONTROLLER_NAME = "calculations";
const CONTROLLER_VERSION = 1;
const ENDPOINT = "leasing-period-fee";

export async function calculatePeriodFee(request: PeriodFeeRequestModel, abortController: AbortController): Promise<PeriodFeeResponseModel> {
  const fullPath = `${CONTROLLER_NAME}/${ENDPOINT}`;
  const requestBody = JSON.stringify(request);
  return await sendApiRequest(fullPath, "POST", CONTROLLER_VERSION, abortController.signal, requestBody);
}
